import React, { useContext } from "react";
import { MessageCard } from "@nykaa/payment-ui/src/MessageCard";
import { useTheme } from "emotion-theming";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { CommonContextContext } from "wrapper/CommonWrapper/context";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { getCookie } from "helpers/utils/cookie";
import { AddressNotMatchedMessageCardWrapper } from "./assets/styles";


/**
 *
 * @description AddressNotMatchedMessageCard is to show the messag card on the checkout page in case of the anonymous pincode entered by the user on the cart or pdp
 * is rendered on the basis of the isAddressIdDelCookiePresent and state value
 */
interface AddressNotMatchedMessageCardInterface {
  defaultAddressMessage?: string;
  leadingIcon?: string | (() => SVGElement|JSX.Element)
}
export const AddressNotMatchedMessageCard = (props: AddressNotMatchedMessageCardInterface) => {
  const { defaultAddressMessage, leadingIcon } = props;

  const theme: Theme = useTheme();
  const { applicationData } = useContext(ApplicationContext);
  const { cartInfo } = useContext(CommonContextContext);
  const { EDD } = useContext(ExperimentAndSwitchContext);

  const pinCodeDel = getCookie("pinCodeDel");

  const { isApp } = applicationData;
  const shippingAddress = cartInfo?.shippingAddress;
  /**
   * for showing defaultAddressMessage on msite we are setting pincodeDel cookie on cart and then consuming that cookie on checkout
   * but for webview we are getting pincode in cart refresh call from apps through callback
   */
  const isVisibleOnMsite = pinCodeDel && shippingAddress?.postcode !== pinCodeDel;
  const isVisibleOnApp = cartInfo?.pincode && shippingAddress?.postcode !== cartInfo?.pincode;

  const isVisible = isApp ? isVisibleOnApp : isVisibleOnMsite;

  if (EDD?.switchEnabled && shippingAddress && isVisible) {
      return (
        <AddressNotMatchedMessageCardWrapper className="layout vertical mrl20">
          <MessageCard
            isHidden={false}
            theme={theme}
            message={{
              text: defaultAddressMessage,
              info: true,
              leadingIcon: leadingIcon,
              font: theme.typography.messageCardText,
            }}
          />
        </AddressNotMatchedMessageCardWrapper>
      );
  };

  return null;
};
